export default __webpack_public_path__ + "static/@Mineral-Pool-QLD_1-978f5df9ddfe9d50a38cca4974829753.jpg";